import React, { Component } from 'react';

import PasswordWithConfirmationInput from './PasswordWithConfirmationInput';
import { getPasswordValidationRules, getPasswordValidationRulesUpdated } from '../../../utils/inputValidations';
import { joinClasses } from '../../../utils/helpers';
import withFeatureFlags from '../../FeatureFlags/withFeatureFlags';

/** @import { ChangePasswordWithConfirmationInputProps, ChangePasswordWithConfirmationInputState } from './ChangePasswordWithConfirmationInputTypes' */

/** @extends {Component<ChangePasswordWithConfirmationInputProps, ChangePasswordWithConfirmationInputState>} */
class ChangePasswordWithConfirmationInput extends Component {
    /** @type {ChangePasswordWithConfirmationInputState} */
    state = { password: '', valid: false };

    get passwordRules() {
        const { profile, featureEnabled } = this.props;
        const useNewPolicy = typeof featureEnabled === 'function' && featureEnabled('DashboardPasswordPolicyV2Enabled');
        return useNewPolicy
            ? getPasswordValidationRulesUpdated(profile.email)
            : getPasswordValidationRules(profile.firstName, profile.email, profile.lastName);
    }

    setPassword = (/** @type {boolean} */ validPassword, /** @type {string} */ password) => {
        this.setState({ password }, () => {
            this.validate(validPassword);
        });
    }

    validate(/** @type {boolean} */ validPassword) {
        const { onChange } = this.props;
        const valid = validPassword;

        this.setState({ valid }, () => {
            const { password, valid } = this.state;
            if (onChange) onChange(valid ? password : null);
        });
    }

    render() {
        const { className, alwaysShowValidations} = this.props;

        let fullClassName = joinClasses('edit-password__input', className);

        return (
            <>
                <PasswordWithConfirmationInput
                    alwaysShowValidations={alwaysShowValidations}
                    className={fullClassName}
                    onChangeWithMatch={this.setPassword}
                    rules={this.passwordRules}
                    placeholder="Password"
                />
            </>
        );
    }
}

export default withFeatureFlags(ChangePasswordWithConfirmationInput);
